
  import { Component, Vue } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import ChoosePages from '@/components/choosepages/choosepages.vue';
	import UploadImg from '@/components/upload-img.vue';
	import PickerDate from '@/components/picker-date.vue';
	import Message from '@/components/message.vue';
  import {
    memberMessagememberMessageNoticeInfo,
    memberMessagememberMessageNoticeSave,
    memberMessagememberMessageNoticeMemberCount,
  } from "@/api/material"
  import {
    pagetypelist
  } from "@/utils/config"
import { nextDay } from '@/utils';
  @Component({  
    name: '',
    components: {
      PageFooter,
      ChoosePages,
      UploadImg,
      PickerDate,
			'slz-message': Message,
    }
  })

  export default class ProductList extends Vue {
    private loading = false
    private form:any = {
      Title:'',
      Content:'',
      PushConditions:1,
      JumpType:'',
      JumpId:'',
      JumpPath:'',
      JumpLabel:'',
      FileName:'',
      FileUrl:[],
      RoleIds:[],
      RegisterStartTime:'',
      RegisterEndTime:'',
      LatelyStartTime:'',
      LatelyEndTime:'',
      PushTime:'',
      zhuceshijian:'',
      xiadanshijian:'',
      PushState:0,
    }
    private gradelist = [
      {
				label: 'SVIC',
				value: 1
			}, {
				label: 'VIC',
				value: 2
			}, {
				label: 'VIP',
				value: 3
			}, {
				label: '客户',
				value: 0
			}
    ]
    private IsChangeFile = false
    private show =false
    private choosemsg:any = {}
    private filsuc = false
    private num = 0
    private options = {
      disabledDate:(e)=>{
        return e.getTime() <= new Date().getTime()-1000*60*60*24
      }
    }
    private pushShow = false

    private mounted () {
      if(Number(this.$route.query.Id)){
        this.getinfo()
      }
    }

    private async getinfo(){
      try{
        this.loading = true
        let res = await memberMessagememberMessageNoticeInfo({
          Id:this.$route.query.Id
        })
        if(res.IsSuccess){
          let form = res.Result
          form.FileUrl = form.FileUrl?[form.FileUrl]:[]
          form.JumpLabel = this.getlabel({pagetype:form.JumpType})
          if(form.RegisterStartTime||form.RegisterEndTim){
            form.zhuceshijian = form.RegisterStartTime.substring(0,10)+'/'+nextDay(form.RegisterEndTime.substring(0,10),-1)
          }
          if(form.LatelyStartTime||form.LatelyEndTime){
            form.xiadanshijian = form.LatelyStartTime.substring(0,10)+'/'+nextDay(form.LatelyEndTime.substring(0,10),-1)
          }

          this.choosemsg = {
            pagetype:form.JumpType,
            PageName:form.JumpPageName,
            PageUrl:form.JumpPath,
            Id:form.JumpId,
          }
          this.form = form
          this.getfileNum()
        }
      }finally{
        this.loading = false
      }
    }

    private test(){
      let data = this.form
      if(!data.Title){
        this.$message.error('请输入推送标题')
        return false
      }
      if(!data.Content){
        this.$message.error('请输入推送内容')
        return false
      }
      if(!this.choosemsg.pagetype){
        this.$message.error('请选择跳转链接')
        return false
      }
      if(data.PushConditions==1){
        if(!data.FileUrl||!data.FileUrl.length){
          this.$message.error('请选择附件上传')
          return false
        }
      }else if(data.PushConditions==2){
        //
      }
      return true
    }
    private async save(isPush){
      if(!this.test()) return
      let form = JSON.parse(JSON.stringify(this.form))
      form.RegisterStartTime = ''
      form.RegisterEndTime = ''
      form.LatelyStartTime = ''
      form.LatelyEndTime = ''
      if(form.PushConditions==1){
        form.RoleIds = []
        form.zhuceshijian = ''
        form.xiadanshijian = ''
      }else{
        form.FileName = ''
        form.FileUrl = ''
        this.IsChangeFile = false
      }
      try{
        this.loading = true
        let data:any = {
          ...form,
          FileUrl:form.FileUrl[0],
        }
        if(data.zhuceshijian){
          let time = data.zhuceshijian.split('/')
          data.RegisterStartTime = time[0]
          data.RegisterEndTime = nextDay(time[1],1)
        }
        if(data.xiadanshijian){
          let time = data.xiadanshijian.split('/')
          data.LatelyStartTime = time[0]
          data.LatelyEndTime = nextDay(time[1],1)
        }
        let res:any = await memberMessagememberMessageNoticeSave({
          Info:data,
          IsImmediatelyPush:isPush,
          IsChangeFile:this.IsChangeFile,
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$router.go(-1)
        }
      }finally{
        this.loading = false
      }
    }
    private uploadSuc(file,name){
      this.form.FileUrl = file
      this.form.FileName = name
      this.IsChangeFile  = true
      this.getfileNum()
    }
    private async getfileNum(){
      if(this.form.PushConditions==1&&(!this.form.FileUrl||!this.form.FileUrl.length)) return
      if(this.form.PushConditions==2&&(!this.form.RoleIds||!this.form.RoleIds.length)&&!this.form.zhuceshijian&&!this.form.xiadanshijian){
        this.num = 0
        return
      }
      try{
        let data:any = {
          FileName:this.form.FileName,
          FileUrl:this.form.FileUrl[0],
          PushConditions:this.form.PushConditions,
          RoleIds:this.form.RoleIds,
        }
        if(this.form.zhuceshijian){
          let time = this.form.zhuceshijian.split('/')
          data.RegisterStartTime = time[0]
          data.RegisterEndTime = nextDay(time[1],1)
        }
        if(this.form.xiadanshijian){
          let time = this.form.xiadanshijian.split('/')
          data.LatelyStartTime = time[0]
          data.LatelyEndTime = nextDay(time[1],1)
        }
        let res = await memberMessagememberMessageNoticeMemberCount(data)
        // console.log(res)
        if(res.IsSuccess){
          this.filsuc = true
          this.num = res.Result.MemberCount
        }
      }catch{
        this.filsuc = false
        this.num = 0
      } finally{
        //
      }
    }
    private getdata(e){
      // console.log(e)      
      this.choosemsg = e
      this.form.JumpType = e.pagetype||'',
      this.form.JumpPageName = e.label||'',
      this.form.JumpPath = '/'+e.pageurl||'',
      this.form.JumpId = e.Id||'',
      this.form.JumpLabel = this.getlabel(e)||'',
      // console.log(this.form.JumpPageName,'e')
      this.show = false
    }
    private choosepage(){
      this.show = true
    }
    private clear(){
      this.choosemsg = {}
      this.form.JumpId = ''
      this.form.JumpLabel = ''
      this.form.JumpPageName = ''
      this.form.JumpPath = ''
      this.form.JumpType = ''
    }
    private getlabel(e){
      // console.log(e,pagetypelist.find(v=>v.value==e.pagetype)?.label)
      return pagetypelist.find(v=>v.value==e.pagetype)?.label
    }
  }
